import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { messagesApi, type PostMessageInput, type ThreadViewMode } from '@/api/messagesApi'
import { TICKET_COUNTS_KEY } from '@/hooks/useTicketCounts'

export function useMessages(routeId: string, view: ThreadViewMode) {
  return useQuery({
    queryKey: ['ticket-messages', routeId, view],
    queryFn: () => messagesApi.list(routeId, view),
    enabled: Boolean(routeId),
    staleTime: 10_000,
  })
}

export function usePostMessage(routeId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: PostMessageInput) => messagesApi.post(routeId, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['ticket-messages', routeId] })
      void queryClient.invalidateQueries({ queryKey: ['ticket', routeId] })
      void queryClient.invalidateQueries({ queryKey: ['ticket-audit', routeId] })
      void queryClient.invalidateQueries({ queryKey: ['tickets'] })
      void queryClient.invalidateQueries({ queryKey: TICKET_COUNTS_KEY })
    },
  })
}
